import { defineMessages } from 'react-intl';

export const scope = 'app.components.CreateAssessmentForm';

export default defineMessages({
  lblName: {
    id: `${scope}.lblName`,
    defaultMessage: 'Assessment Name'
  },
  lblYear: {
    id: `${scope}.lblYear`,
    defaultMessage: 'Year'
  },
  lblSeason: {
    id: `${scope}.lblSeason`,
    defaultMessage: 'Season'
  },
  lblDescriptor: {
    id: `${scope}.lblDescriptor`,
    defaultMessage: 'Descriptor'
  },
  lblAdditionalContext: {
    id: `${scope}.lblAdditionalContext`,
    defaultMessage: 'Additional Context (Optional)'
  },
  btnCreate: {
    id: `${scope}.btnCreate`,
    defaultMessage: 'Create Assessment',
  },
  btnUpdate: {
    id: `${scope}.btnUpdate`,
    defaultMessage: 'Update Assessment',
  },
  btnSubmitting: {
    id: `${scope}.btnSubmitting`,
    defaultMessage: 'Saving...',
  },
  lblInfoLink: {
    id: `${scope}.lblInfoLink`,
    defaultMessage: 'Link to Evaluation Information & Schedule (used in Welcome Email)',
  },
  lblConcludeEmailTemplate: {
    id: `${scope}.lblConcludeEmailTemplate`,
    defaultMessage: 'Designate the type of Conclusion Email Template you would like to use',
  },
  lblCompanyIntroLink: {
    id: `${scope}.lblCompanyIntroLink`,
    defaultMessage: 'Evaluation Group Link (ie. Intro Videos, used in Welcome Email)'
  },
  lblCompanyEvaluationGroupName: {
    id: `${scope}.lblCompanyEvaluationGroupName`,
    defaultMessage: 'Evaluation Group Name (used in Welcome Email)'

  },
});
